import { render, staticRenderFns } from "./EDPSweb.vue?vue&type=template&id=186c19b8&scoped=true&"
import script from "./EDPSweb.vue?vue&type=script&lang=js&"
export * from "./EDPSweb.vue?vue&type=script&lang=js&"
import style0 from "./EDPSweb.vue?vue&type=style&index=0&id=186c19b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "186c19b8",
  null
  
)

export default component.exports